import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import seedrandom from "seedrandom"
import $ from "jquery";
import {ContextualMenu} from "./ContextualMenu";

export const DRAGGABLE_SCENE_POSITIONING = {
  "ARC": 2,
  "LEFT_RIGHT": 3,
  "STARFIELD": 4,
  "LEVEL2": 5,
};

export const DRAGGABLE_SCENE_LOCK_BEHAVIOUR = {
  "HIDE": 2,
  "VISIBLE": 3,
  "VISIBLE_FLOAT": 4,
};

export class DraggableScene {

  constructor({
                selector,
                positionMode,
                elementsCountByDropzone = 1,
                dropzoneProgressCallback = null,
                dropzoneCompletedCallback = null,
                allCompletedCallback = null,
                contextualMenu = null,
                lockBehavior = DRAGGABLE_SCENE_LOCK_BEHAVIOUR.HIDE,
                grabRadius = 0,
                maxAttempts = -1,
              }) {
    this.$el = $(selector);
    this.$draggablesEl = [];
    this.$dropZonesEl = [];
    this.currentDropZoneContent = [];
    this.contextualMenu = contextualMenu;

    this.positionMode = positionMode;
    this.elementsCountByDropzone = elementsCountByDropzone; // Number of required draggable to complete a drop zone
    this.lockBehavior = lockBehavior;

    this.grabRadius = grabRadius;
    this.grabbedAdditionalEl = [];

    this.dropzoneProgressCallback = dropzoneProgressCallback; // Called when a drop zone has progress
    this.dropzoneCompletedCallback = dropzoneCompletedCallback; // Called when one drop zone is completed
    this.allCompletedCallback = allCompletedCallback; // Called when all drop zones are completed

    this.rng = seedrandom('danserchanter');
    this.rng2 = seedrandom('chateretrier2');

    this.bounds = (this.positionMode === DRAGGABLE_SCENE_POSITIONING.ARC) ? {top: 100, left: 50, width: 1820, height: 760} : {top: 0, left: 0, width: 1920, height: 860};
    this.deployedSizeOffset = (this.positionMode === DRAGGABLE_SCENE_POSITIONING.ARC) ? 35 : 0;

    this.attempts = 0;
    this.maxAttempts = maxAttempts;

    this.init();
  }

  init() {
    this.$draggablesEl = this.$el.find(".draggable");
    this.$dropZonesEl = this.$el.find(".dropzone");

    // Place draggable randomly in space
    this.randomizeInitialPosition();

    // Save initial positions
    this.$draggablesEl.each((i, n) => {
      const currentX = gsap.getProperty(n, "x");
      const currentY = gsap.getProperty(n, "y");
      $(n).data("initial-position", {x: currentX, y: currentY})
      $(n).data("locked-dropzone", null)
      $(n).data('random', this.rng());
      // if ($(n).data("affected-by-size") === true) {
      //   // Apply size to DOM attr so it can be used by CSS
      //   const size = app.data.content.elements.find(item => item.code === $(n).data("type")).size;
      //   const mappedSize = Math.round(map(constrain(size, 5, 9), 5, 9, -2, 2))
      //   $(n).attr("data-molecule-size", mappedSize)
      // }
    });

    // Build drop zone logic variables
    this.$dropZonesEl.each((i, n) => {
      $(n).data("index", i)
      this.currentDropZoneContent.push({
        index: i,
        content: [],
      });
    });

    // Make element draggable and bind event listener
    this.createDraggableInstances();

    this.disable();
  }

  randomizeInitialPosition() {

    if (this.positionMode === DRAGGABLE_SCENE_POSITIONING.ARC) {
      const width = (this.bounds.width / 2) - (this.deployedSizeOffset);
      const height = 400;

      this.$draggablesEl.each((i, n) => {
        const r1 = this.rng();
        const r2 = map(this.rng(), 0, 1, 0.1, 1); // Set to 1 to get a better understanding
        gsap.set(n, {
          // x: map(this.rng(), 0, 1, 62, 1920 - 62),
          // y: map(this.rng(), 0, 1, 62, 1080 - 62),
          x: (Math.cos(r1 * Math.PI + Math.PI)) * (width * r2) + width + this.bounds.left + this.deployedSizeOffset,
          y: (Math.sin(r1 * Math.PI + Math.PI)) * (height * r2) + height + this.bounds.top + this.deployedSizeOffset,
        });
      })

    } else if (this.positionMode === DRAGGABLE_SCENE_POSITIONING.LEFT_RIGHT) {
      const width = 1920 / 2 - 200;
      const middleSpace = 400;
      this.$draggablesEl.each((i, n) => {
        const randomZebra = this.rng2() >= 0.5;
        const leftRightOffset = (randomZebra) ? width + middleSpace : 0;
        gsap.set(n, {
          x: map(this.rng(), 0, 1, 62, width - 62) + leftRightOffset,
          y: map(this.rng(), 0, 1, 62, 850),
        });
      })
    } else if (this.positionMode === DRAGGABLE_SCENE_POSITIONING.STARFIELD) {
      const width = 1920 - 100;
      const height = 800;
      this.$draggablesEl.each((i, n) => {
        const r1 = this.rng();
        const r2 = map(this.rng(), 0, 1, 0.1, 1); // Set to 1 to get a better understanding
        gsap.set(n, {
          x: r1 * width + 50,
          y: r2 * height + 20,
        });
      })
    } else if (this.positionMode === DRAGGABLE_SCENE_POSITIONING.LEVEL2) {
      const targets = [
        {x: 400, y: 250, rx: 300, ry: 200, ratio: 3},
        {x: 1500, y: 250, rx: 300, ry: 200, ratio: 3},
        {x: 960, y: 670, rx: 200, ry: 160, ratio: 1},
        {x: 200, y: 670, rx: 150, ry: 160, ratio: 1},
        {x: 1700, y: 670, rx: 150, ry: 160, ratio: 1},
      ];
      const targetsWithRatio = targets.reduce((acc, target) => {
        for (let i = 0; i <= target.ratio; i++) acc.push(target);
        return acc
      }, [])
      this.$draggablesEl.each((i, n) => {
        const targetPosition = targetsWithRatio[Math.floor(this.rng() * targetsWithRatio.length)];
        const r1 = map(this.rng(), 0, 1, 0, Math.PI * 2);
        const r2 = map(this.rng(), 0, 1, 0, Math.PI * 2);
        const r3 = map(this.rng(), 0, 1, 0.3, 1); // Set to 1 to get a better understanding
        gsap.set(n, {
          x: targetPosition.x + Math.cos(r1) * r3 * targetPosition.rx,
          y: targetPosition.y + Math.sin(r2) * r3 * targetPosition.ry,
        });
      })
    }

  }

  floatElement(n) {
    return DraggableScene.floatElement(n)
  }

  static floatElement(n) {
    const basicConfig = {
      yoyo: true,
      repeat: -1,
      overwrite: "auto",
      ease: "sine.inOut"
    };

    gsap.to(n, {
      y: "+=" + (Math.random() + 1) * 10 * (Math.random() > 0.5 ? -1 : 1),
      duration: (Math.random() + 1) * 2,
      ...basicConfig
    });

    gsap.to(n, {
      x: "+=" + (Math.random() + 1) * 10 * (Math.random() > 0.5 ? -1 : 1),
      duration: (Math.random() + 1) * 2,
      ...basicConfig
    });
  }

  attractAll(x, y) {
    this.$draggablesEl.each((i, n) => {
      const duration = map(Math.random(), 0, 1, 1.5, 3);
      gsap.killTweensOf(n)
      gsap.to(n, {
        x: x,
        y: y,
        ease: "power1.in",
        duration: duration,
        scale: 0.3,
      });
      gsap.to(n, {
        alpha: 0,
        ease: "power1.in",
        duration: duration / 2,
        delay: duration / 2,
      });
    })
    return this;
  }

  createDraggableInstances() {

    // This is old school `this` scope handling for 'snap' function
    const _this = this;

    function lockOrFloat(draggable) {
      const dropZone = $(draggable.target).data("locked-dropzone");
      if (dropZone !== null) _this.lockItem(draggable, dropZone);
      else _this.floatElement(draggable.target)

      // Free additional draggables grabbed by radius
      if (dropZone === null || _this.lockBehavior === DRAGGABLE_SCENE_LOCK_BEHAVIOUR.VISIBLE_FLOAT) {
        while (_this.grabbedAdditionalEl.length > 0) {
          const additionalDraggable = _this.grabbedAdditionalEl.pop();
          additionalDraggable.enable();
        }
      }
    }

    this.$draggablesEl.get().forEach((n) => {
      const draggableInstance = Draggable.create(n, {
        inertia: true,
        allowEventDefault: true,
        throwResistance: 5000,
        zIndexBoost: 98,
        bounds: this.bounds,
        onDragStart: function () {
          const draggable = this;
          if (draggable) $(draggable.target).data("locked-dropzone", null)
          // Prevent dragging when a contextual menu is available (level 3) and molecule is not expanded
          if (_this.contextualMenu && !$(draggable.target).hasClass("expanded")) {
            draggable.endDrag();

            // Visual feedback when user tries to drag without using contextual menu
            // gsap.to(draggable.target, {
            //   scale: 1.1,
            //   yoyo: true,
            //   repeat: 3,
            //   duration: 0.2,
            //   ease: "circ.inOut",
            // })

            _this.contextualMenu.open(this);
          }

          // Only add grabbed additional if there are currently none (avoids having more than 5)
          if (_this.grabbedAdditionalEl.length === 0) {
            _this.grabbedAdditionalEl.push(..._this.getElementsForRadius.bind(_this)(draggable, this.x, this.y, _this.grabRadius));
          }

        },
        onDrag: function (e) {
          // Move additional draggables grabbed by radius
          for (const additionalDraggable of _this.grabbedAdditionalEl) {
            const offset = $(additionalDraggable.target).data("offset-from-main");
            const velocity = $(additionalDraggable.target).data('random');
            gsap.killTweensOf(additionalDraggable.target)
            gsap.to(additionalDraggable.target, {x: this.x + offset.x, y: this.y + offset.y, duration: 0.3 * velocity + 0.05});
          }
        },
        onDragEnd: function (e) {
          // Under 25 pixel, set back tool position without delay
          const initialPosition = $(this.target).data("initial-position");
          const distance = dist(initialPosition.x, initialPosition.y, this.x, this.y);
          if (distance < 25) {
            this.tween.kill();
            lockOrFloat(this)
          }
        },
        onThrowComplete: function () {
          lockOrFloat(this)
        },
        snap: {
          points: function (point) {
            const draggable = this;
            const dropzone = _this.getLockableDropZone(point)
            if (dropzone) {
              const dropzonePos = dropzone.getBoundingClientRect()
              $(draggable.target).data("locked-dropzone", dropzone)
              return {
                x: dropzonePos.x + (dropzonePos.width / 2),
                y: dropzonePos.y + (dropzonePos.height / 2)
              };
            } else {
              $(draggable.target).data("locked-dropzone", null)
              return point;
            }
          }
        },
      })[0];

      if (this.contextualMenu) {
        draggableInstance.addEventListener("click", function () {
          if (!$(this.target).hasClass("expanded")) _this.contextualMenu.open(this);
        });
      }

    })

    Draggable.zIndex = 5;
  }

  getLockableDropZone(point) {
    const $availableDropZones = this.$dropZonesEl.filter(":not(.complete):not(.locked)");
    for (let i = 0; i < $availableDropZones.length; i++) {
      const dropzone = $availableDropZones[i];
      const hits = Draggable.hitTest({
        top: point.y,
        left: point.x,
        right: point.x + 10,
        bottom: point.y + 10
      }, dropzone, 0);
      if (hits) return dropzone
    }
    return null;
  }

  lockItem(draggable, dropZone) {
    const dropZoneIndex = $(dropZone).data("index");
    const type = $(draggable.target).data("type");

    app.audio.play("audio/MNS2_Int1.2 Poussiere cosmique_SFX/MNS2_ME_INT1.2_SFXdepot.mp3", 1, true)

    // Handle completed logic
    this.currentDropZoneContent[dropZoneIndex].content.push(type)
    const revealDropZone = this.currentDropZoneContent[dropZoneIndex].content.length >= this.elementsCountByDropzone;
    if (revealDropZone) $(dropZone).addClass("complete")
    const allCompleted = (this.$dropZonesEl.filter(":not(.complete)").length === 0);

    // Handle progress logic
    if (this.dropzoneProgressCallback) this.dropzoneProgressCallback($(dropZone), this)

    // TODO Debugging, can be removed
    console.log(`Dropped on ${dropZoneIndex}. Current drop zones content is: `, this.currentDropZoneContent)

    // Disable draggable setup during locking
    draggable.disable();

    const tl = gsap.timeline();

    // Animate draggable out
    if (this.lockBehavior === DRAGGABLE_SCENE_LOCK_BEHAVIOUR.HIDE) {
      tl.to(draggable.target, {
        scale: 0,
        opacity: 0,
        duration: 0.3,
        ease: "back.in(1.7)",
      })
    }

    // Floating behavior after lock when requested (for level 2)
    if (this.lockBehavior === DRAGGABLE_SCENE_LOCK_BEHAVIOUR.VISIBLE_FLOAT) {
      for (const additionalDraggable of [draggable, ...this.grabbedAdditionalEl]) {
        const rect = additionalDraggable.target.getBoundingClientRect()
        const random = $(additionalDraggable.target).data('random');
        const currentPos = {
          x: rect.left + rect.width / 2,
          y: rect.top + rect.height / 2,
        }
        const target = {
          x: currentPos.x - ((currentPos.x - draggable.x) * 0.4),
          y: currentPos.y - ((currentPos.y - draggable.y) * 0.4),
        }
        tl.to(additionalDraggable.target, {...target, scale: 0.6, duration: 0.2 + 0.5 * random, ease: "sine.out"}, '<');
        $(additionalDraggable.target).addClass("shrinkable")
      }
      for (const additionalDraggable of [draggable, ...this.grabbedAdditionalEl]) {
        tl.add(() => this.floatElement(additionalDraggable.target));
      }
    }

    // Reveal dropzone result if required
    if (revealDropZone) tl.add(() => this.revealDropZoneResult(dropZoneIndex));

    // Reveal all completed result if required, and stop here
    if (allCompleted) {
      tl.add(() => this.revealAllCompletedResult());
      tl.add(() => ContextualMenu.removeLottieCanvas(draggable))
      return;
    }

    if (this.lockBehavior !== DRAGGABLE_SCENE_LOCK_BEHAVIOUR.HIDE) return;

    // Restore drag behaviour and position
    const initialPosition = $(draggable.target).data("initial-position");
    tl.set(draggable.target, {
      x: initialPosition.x,
      y: initialPosition.y,
    });

    // Remove elements created by contextual menu
    tl.add(() => ContextualMenu.removeLottieCanvas(draggable))

    // Bring back the element at its original position
    tl.to(draggable.target, {
      scale: 1,
      opacity: 1,
      duration: 0.3,
      ease: "sine.out",
    }, "+=1")

    // Resume draggable after animation
    tl.add(() => {
      $(draggable.target).data("locked-dropzone", null);
      this.floatElement(draggable.target)
      draggable.enable();
    });
  }

  moveBackToInitialPosition(slotsValidation) {

    const tl = gsap.timeline();

    const lockedElements = this.$draggablesEl.get().filter((item) => {
      return ($(item).data("locked-dropzone") != null)
    }).sort(function (a, b) {
      const aIndex = $($(a).data("locked-dropzone")).index()
      const bIndex = $($(b).data("locked-dropzone")).index()
      return aIndex - bIndex;
    })

    // Delay start
    tl.add(() => {
    }, 1)

    for (const lockedElement of lockedElements) {
      const initialPosition = $(lockedElement).data("initial-position");
      const draggable = Draggable.get(lockedElement);
      const dropzone = $(lockedElement).data("locked-dropzone");
      const dropzoneIndex = $(dropzone).index();

      // Keep good answers
      if (slotsValidation[dropzoneIndex]) continue;

      // Restore original position
      tl.to(lockedElement, {
        x: initialPosition.x,
        y: initialPosition.y,
        duration: 0.7,
        ease: "sine.out",
        onComplete: () => {
          // Restore original behavior
          $(dropzone).removeClass("complete")
          this.currentDropZoneContent[$(dropzone).index()].content = [];
          $(lockedElement).data("locked-dropzone", null);
          this.floatElement(lockedElement)
          draggable.enable();
        }
      }, "<+=0.2");

    }

    // Remove dropzone feedback
    for (const lockedElement of lockedElements) {
      const dropzone = $(lockedElement).data("locked-dropzone");
      tl.to($(dropzone).find("canvas"), {
        autoAlpha: 0,
      }, 3);

      tl.add(() => {
        for (const lottieEl of $(dropzone).find(`canvas.lottie-animation`).get()) {
          const lottie = $(lottieEl).data('lottie');
          lottie.setFrame(0)
          lottie.pause();
        }
      });
    }

    return tl

  }

  revealDropZoneResult(dropZoneIndex) {
    console.log("revealDropZoneResult", dropZoneIndex)
    const $dropZoneEl = this.$dropZonesEl.eq(dropZoneIndex);
    if (this.dropzoneCompletedCallback) return this.dropzoneCompletedCallback($dropZoneEl, this)
  }

  getProgressCount(dropZoneIndex) {
    return this.currentDropZoneContent[dropZoneIndex].content.length;
  }

  revealAllCompletedResult() {
    const allCompleted = (this.$dropZonesEl.filter(":not(.complete)").length === 0);
    if (this.allCompletedCallback && allCompleted) return this.allCompletedCallback();
  }

  level2DropzoneUnlock(dropzoneIndex, animate = true) {
    this.$dropZonesEl.eq(dropzoneIndex).removeClass("locked");
    const lottie = this.$dropZonesEl.eq(dropzoneIndex).find(".cta-image canvas").data("lottie")

    if (animate) {
      lottie.stateMachineLoad("StateMachine1")
      lottie.setMarker("UNLOCK");
      lottie.play();
    } else {
      lottie.stateMachineLoad("StateMachine1")
      lottie.setMarker("LOOP");
      lottie.setLoop(true);
      lottie.play();
    }
  }

  level2DropzoneLock(dropzoneIndex) {
    this.$dropZonesEl.eq(dropzoneIndex).addClass("locked");
    const lottie = this.$dropZonesEl.eq(dropzoneIndex).find(".cta-image canvas").data("lottie")
    lottie.stateMachineLoad("")
    lottie.setMarker("STILL");
    lottie.setFrame(0);
    lottie.setLoop(false);
    lottie.play();
  }

  animateIn(enable = false) {
    const tl = gsap.timeline();

    for (let i = 0; i < this.$draggablesEl.length; i++) {
      const n = this.$draggablesEl.eq(i);
      const startAt = map(Math.random(), 0, 1, 0, 1)
      tl.fromTo(n, {
        scale: 0.3,
        opacity: 0,
      }, {
        scale: 1,
        opacity: 1,
        duration: 1.4,
        ease: "back.out(1.7)",
      }, startAt)
    }

    if (enable) tl.add(this.enable.bind(this));

    return tl;
  }

  animateOut() {
    const tl = gsap.timeline();
    for (let i = 0; i < this.$draggablesEl.length; i++) {
      const n = this.$draggablesEl.eq(i);
      const startAt = map(Math.random(), 0, 1, 0, 1)
      tl.to(n, {
        scale: 0.3,
        opacity: 0,
        duration: 1.4,
        ease: "back.out(1.7)",
      }, startAt)
    }
    return tl;
  }

  shrinkShrinkable($dropZoneEl) {
    const tl = gsap.timeline();
    const rect = $dropZoneEl.get(0).getBoundingClientRect()
    const target = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    }
    $(".shrinkable").each((i, n) => {
      gsap.killTweensOf(n);
      tl.to(n, {
        ...target,
        scale: 0.3,
        opacity: 0,
        duration: 0.8,
        ease: "back.in(1.7)",
      }, 0);
    });

    return tl;
  }

  enable() {
    this.$draggablesEl.each((i, n) => {
      const draggable = Draggable.get(n);
      draggable.enable();
      this.floatElement(n)
    });
    return this;
  }

  disable(killTweens = true) {
    this.$draggablesEl.each((i, n) => {
      const draggable = Draggable.get(n);
      draggable.disable();
      if (killTweens) gsap.killTweensOf(n);
    });
    return this;
  }

  getElementsForRadius(self, x, y, radius, limit = 5) {
    const candidates = [];
    const output = [];
    for (const n of this.$draggablesEl) {
      if ($(n).hasClass("shrinkable")) continue;
      const boundingClientRect = $(n).get(0).getBoundingClientRect();
      const currentPosition = {x: boundingClientRect.x + boundingClientRect.width / 2, y: boundingClientRect.y + boundingClientRect.height / 2};
      const distanceFromPoint = dist(currentPosition.x, currentPosition.y, x, y);
      if (distanceFromPoint <= radius && distanceFromPoint > 0) {
        // Close enough
        const draggable = Draggable.get(n);
        if (draggable === self || this.grabbedAdditionalEl.includes(draggable)) continue;
        candidates.push({
          distance: distanceFromPoint,
          draggable: draggable,
          // angle: Math.atan2(currentPosition.y - y, currentPosition.x - x),
          offset: {x: currentPosition.x - x, y: currentPosition.y - y},
        });
      }
    }

    // Sort by distances
    candidates.sort((a, b) => a.distance - b.distance);

    // Stop floating of selected element and save some value
    for (const candidate of candidates) {
      if (output.length >= limit) break;
      candidate.draggable.disable()
      gsap.killTweensOf(candidate.draggable.target);
      $(candidate.draggable.target).data("offset-from-main", candidate.offset)
      output.push(candidate.draggable);
    }

    // Return selected draggables
    return output;
  }

  pushAtPoint(x, y, radius) {
    for (const n of this.$draggablesEl) {
      const boundingClientRect = $(n).get(0).getBoundingClientRect();
      const currentPosition = {x: boundingClientRect.x + boundingClientRect.width / 2, y: boundingClientRect.y + boundingClientRect.height / 2};
      const distanceFromPoint = dist(currentPosition.x, currentPosition.y, x, y);
      if (distanceFromPoint <= radius && distanceFromPoint > 0) {
        // Close enough
        const draggable = Draggable.get(n);
        const angle = Math.atan2(currentPosition.y - y, currentPosition.x - x)
        const bounds = {
          left: this.bounds.left + boundingClientRect.width / 2 + this.deployedSizeOffset,
          right: (this.bounds.left + this.bounds.width) - boundingClientRect.width / 2 - this.deployedSizeOffset,
          top: this.bounds.top + boundingClientRect.height / 2 + this.deployedSizeOffset,
          bottom: (this.bounds.top + this.bounds.height) - boundingClientRect.height / 2 - this.deployedSizeOffset,
        }
        draggable.disable()
        gsap.killTweensOf(n);
        gsap.to(n, {
          x: constrain(currentPosition.x + Math.cos(angle) * (radius - distanceFromPoint), bounds.left, bounds.right),
          y: constrain(currentPosition.y + Math.sin(angle) * (radius - distanceFromPoint), bounds.top, bounds.bottom),
          onComplete: draggable.enable
        });
      }
    }
  }


  reset() {
    this.attempts = 0;

    this.$draggablesEl.each((i, n) => {
      const draggable = Draggable.get(n);
      ContextualMenu.removeLottieCanvas(draggable);
      $(n).removeClass("shrinkable")
      const initialPosition = $(n).data("initial-position");
      gsap.set(n, {
        x: initialPosition.x,
        y: initialPosition.y,
        scale: 1,
        opacity: 1,
      });
    });

    // Clear dropzone related variables
    this.$dropZonesEl.each((i, n) => {
      $(n).removeClass("complete")
      this.currentDropZoneContent[i].content = [];
      gsap.set(n, {
        scale: 1,
        opacity: 1,
        rotation: 0,
      });

      if ($(".cta-image", n).length > 0) gsap.set($(".cta-image", n), {autoAlpha: 1});
      if ($(".result-image", n).length > 0) gsap.set($(".result-image", n), {autoAlpha: 0});
    });

    // Restart zIndex static counter
    Draggable.zIndex = 5;

    return this;
  }
}

